import { module as BaseModule } from 'modujs'

export default class extends BaseModule {
  constructor(m) {
    super(m)

    this.events = {
      click: {
        more: 'onClickMore',
      },
    }
  }

  init() {
    this.items = this.el.querySelectorAll('.c-projects__item')
    this.filteredItems = []
    this.button = document.querySelector('[data-increment="more"]')

    this.baseNumber = 4
    this.total = this.items.length
    this.increment = 4
    this.displayedElements = this.baseNumber

    this.displayElements()
  }

  updateState(state) {
    this.reset()
    this.state = state

    if (this.state.type || this.state.year) {
      this.hasFilters = true
      let selector = '.c-projects__item'
      if (state.type) selector += `[data-filter-types*="${state.type}"]`
      if (state.year) selector += `[data-filter-years*="${state.year}"]`

      this.filteredItems = this.el.querySelectorAll(selector)
      this.total = this.filteredItems.length
    } else {
      this.hasFilters = false
      this.items = this.el.querySelectorAll('.c-projects__item')
      this.total = this.items.length
    }

    this.displayElements()
    this.toggleMore()
  }

  onClickMore() {
    // console.log(this.call('reveal', null, 'AnimReveal', this.increment))

    this.displayedElements += this.increment
    this.displayElements()
    this.toggleMore()
  }

  displayElements() {
    if (this.hasFilters) {
      // Hide all items than are not included in this.filteredItems
      this.items.forEach((el) => {
        const isHidden = ![...this.filteredItems].includes(el)
        el.classList.toggle('is-hidden', isHidden)
      })

      // Show filteredItems based on this.displayedElements
      this.filteredItems.forEach((el, i) => {
        const isHidden = i > this.displayedElements - 1
        el.classList.toggle('is-hidden', isHidden)
      })
    } else {
      this.items.forEach((el, i) => {
        const isHidden = i > this.displayedElements - 1
        el.classList.toggle('is-hidden', isHidden)
      })
    }
  }

  toggleMore() {
    const isHidden = this.displayedElements - 1 + this.increment >= this.total
    this.button.classList.toggle('invisible', isHidden)
  }

  reset() {
    this.displayedElements = this.baseNumber
  }
}
